export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8652.45afe7f6.jpg";